<template>
  <div>
    <Table ref="table" :columns="columns" :data="list">
      <template slot-scope="{ row }" slot="time">
        {{ row.time[0] }} - {{ row.time[1] }}
      </template>
      
      <template slot-scope="{ row }" slot="money">
        <a>{{ row.money }}</a>
      </template>

      <template slot-scope="{ row }" slot="status">
        <Badge :status="row.status ? 'error' : 'success'" :text="$t('name.cex_take.status_text')[row.status]" />
      </template>
      
      <template slot-scope="{ row }" slot="created_at">
        <Time :time="row.created_at * 1000" type="datetime" />
      </template>

      <template slot-scope="{ row }" slot="action">
        <Dropdown trigger="click" @on-click="name => onActive(name, row)">
          <a href="javascript:void(0)">
            {{ $t('name.more') }}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem v-if="!row.status" name="no">{{ $t('name.cex_take.active_no') }}</DropdownItem>
            <DropdownItem name="data">{{ $t('name.cex_take.data') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>
    </Table>
    <Modal v-model="json.model" :title="$t('name.cex_take.data')" footer-hide>
      <pre>{{ json.data }}</pre>
    </Modal>
  </div>
</template>
<script>
import { no, noCode } from '@/api/cex_take';

export default {
  props: {
    list: Array,
  },
  data() {
    return {
      columns: [
        {
          title: "ID",
          key: "id",
          width: 100
        },
        {
          title: this.$t("name.cex_take.name"),
          key: "name"
        },
        {
          title: this.$t("name.cex_take.code"),
          key: "code",
          width: 130,
        },
        {
          title: this.$t("name.cex_take.date"),
          key: 'date',
          align: 'center',
          width: 130,
        },
        {
          title: this.$t("name.cex_take.time"),
          slot: 'time',
          align: 'center',
          width: 150,
        },
        {
          title: this.$t("name.cex_take.remarks"),
          key: "remarks",
          width: 300,
        },
        {
          title: this.$t("name.cex_take.status"),
          slot: 'status',
          align: 'center',
          width: 140,
        },
        {
          title: this.$t("name.cex_take.created_at"),
          slot: 'created_at',
          align: 'center',
          width: 180,
        },
        {
          title: this.$t("name.active"),
          slot: 'action',
          width: 120,
          fixed: 'right'
        },
      ],
      json: {
        model: false,
        data: ''
      }
    };
  },
  methods: {
    onActive(name, row) {
      switch (name) {
        case 'no':
          return this.onNo(row)
        case 'data':
          return this.onData(row.data)
      }
    },
    onNo(data) {
      this.$Modal.confirm({
        title: this.$t('name.cex_take.active_no'),
        content: this.$t('name.cex_take.active_no_message'),
        onOk: () => {
          noCode(data).then(() => {
            no(data.id).then(res => {
              this.$emit('get')
              this.$Message.success(this.$t('message.' + res.message))
            }).catch(res => {
              this.$Message.error(this.$t('message.' + res.message))
            })
          }).catch(res => {
            return this.$Message.error(res.message)
          })
        }
      });
    },
    onData(data) {
      this.json.model = true
      this.json.data = JSON.stringify(data, null, 4)
    },
  }
};
</script>